var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2HealthEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59861 10.3896C2.46778 10.1471 2.46778 9.85289 2.59861 9.61039C4.17528 6.69455 7.08778 4.16705 10.0003 4.16705C12.9128 4.16705 15.8253 6.69455 17.4019 9.61122C17.5328 9.85372 17.5328 10.1479 17.4019 10.3904C15.8253 13.3062 12.9128 15.8337 10.0003 15.8337C7.08778 15.8337 4.17528 13.3062 2.59861 10.3896Z",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7678 8.23193C12.7441 9.20823 12.7441 10.7912 11.7678 11.7675C10.7915 12.7438 9.20854 12.7438 8.23223 11.7675C7.25592 10.7912 7.25592 9.20823 8.23223 8.23193C9.20854 7.25562 10.7915 7.25562 11.7678 8.23193",
    stroke: "#7A7670",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2HealthEye);
export default __webpack_public_path__ + "static/media/customV2HealthEye.7de3d402d221e35232b5a54b3320a59f.svg";
export { ForwardRef as ReactComponent };